import styled from "styled-components";
import { AUTH_PAGE_CONTENT_WIDTH } from "../../../styles/variables";
import { Device } from "../../../styles/screenSizes";

export const StyledLayout = styled.div<{ inModal: boolean }>`
  margin: auto;
  max-width: ${AUTH_PAGE_CONTENT_WIDTH};
  display: flex;
  flex-direction: column;

  @media ${Device.mobile} {
    padding-left: 20px;
    padding-right: 20px;
  }

  ${({ inModal }) =>
    !inModal &&
    `
      padding-bottom: 60px;
  `}
`;
